// extracted by mini-css-extract-plugin
export default {"figure":"L7nhp","rating":"JWQxp","ellipsis":"RPKgW","title":"LHadx","image":"EOCtd"};